import { useState } from 'react';
import Button from '@ui/components/atoms/Button';
import Input from '@ui/components/atoms/Input';
import Alert from '@ui/components/molecules/Alert';
import { loginApi } from '../../services/api';

import serojaLogo from '../../assets/images/seroja-logo.png';
import authHeroBg from '../../assets/images/auth-hero-bg.jpg';

export default function LoginPage({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [errors, setErrors] = useState({ username: '', password: '' });
  const [globalAlert, setGlobalAlert] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;
    const newErrors = { username: '', password: '' };

    if (!username.trim()) {
      newErrors.username = 'Username atau nama pengguna wajib diisi.';
      valid = false;
    }
    if (!password) {
      newErrors.password = 'Kata sandi wajib diisi.';
      valid = false;
    }

    setErrors(newErrors);

    if (!valid) return;

    setIsLoading(true);
    setGlobalAlert(null);

    try {
      const response = await loginApi(username, password, remember);
      setIsLoading(false);
      setGlobalAlert({
        type: 'success',
        message: response.message || 'Login berhasil! Mengalihkan ke dashboard...',
      });

      if (onLoginSuccess) {
        setTimeout(() => onLoginSuccess(response.data?.user || { username }), 600);
      }
    } catch (err) {
      setIsLoading(false);
      setGlobalAlert({
        type: 'error',
        message: err.message || 'Username atau kata sandi tidak cocok.',
      });
    }
  };

  return (
    <div className="auth-wrapper">
      {globalAlert && (
        <div className="auth-alert-floating">
          <Alert
            variant={globalAlert.type === 'error' ? 'red' : 'green'}
            title={globalAlert.type === 'error' ? 'Gagal Masuk' : 'Sukses'}
            onClose={() => setGlobalAlert(null)}
          >
            {globalAlert.message}
          </Alert>
        </div>
      )}

      {/* Fullscreen Split Layout */}
      <div className="auth-card-container">

        {/* LEFT PANEL: Rounded Dark Mesh Banner & Version Info */}
        <div className="auth-hero-section">
          <div
            className="auth-hero-card"
            style={{ '--auth-hero-bg': `url(${authHeroBg})` }}
          >

            {/* Top Version Line Header */}
            <div className="auth-hero-header">
              <span className="version-tag">bursaku v0.5.0</span>
              <div className="version-line-rule" />
            </div>

          </div>
        </div>

        {/* RIGHT PANEL: Authentication Form */}
        <div className="auth-form-section">
          <div className="auth-form-container">

            {/* Top Logo Header */}
            <div className="auth-brand-top">
              <img src={serojaLogo} alt="Seroja Makmur" className="brand-logo" />
            </div>

            {/* Center Content Group */}
            <div className="auth-content-group">

              {/* Form Title & Subtitle using Design System Typography */}
              <div className="auth-header-text">
                <h1 className="auth-main-heading">Halo!</h1>
                <p className="auth-sub-heading">Masukan Username dan Password untuk masuk</p>
              </div>

              {/* Login Form */}
              <form onSubmit={handleSubmit} className="auth-form">

                {/* Username Input */}
                <Input
                  label="Username"
                  name="username"
                  id="username"
                  type="text"
                  placeholder="Username kamu"
                  value={username}
                  error={errors.username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                    if (errors.username) setErrors((prev) => ({ ...prev, username: '' }));
                  }}
                />

                {/* Password Input */}
                <Input
                  label="Password"
                  name="password"
                  id="password"
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  isPasswordToggle
                  error={errors.password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (errors.password) setErrors((prev) => ({ ...prev, password: '' }));
                  }}
                />

                {/* Options Row: Remember Me & Forgot Password */}
                <div className="auth-options-row">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      id="remember"
                      checked={remember}
                      onChange={(e) => setRemember(e.target.checked)}
                      className="checkbox-input"
                    />
                    <span>Remember me</span>
                  </label>
                  <a href="#forgot" onClick={(e) => e.preventDefault()} className="forgot-password-link">
                    Forgot Password
                  </a>
                </div>

                {/* Action Buttons using Design System Buttons */}
                <div className="auth-buttons-group">
                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    fullWidth
                    loading={isLoading}
                    className="btn-sign-in"
                  >
                    Sign In
                  </Button>
                </div>

              </form>

            </div>

            {/* Bottom Footer Text */}
            <div className="auth-footer-bottom">
              <p className="signup-prompt">
                Don't have an account?{' '}
                <a href="#signup" onClick={(e) => e.preventDefault()} className="signup-link">
                  Sign Up
                </a>
              </p>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}
